export default { 
  computed: { 
    getAppMode() { 
      return this.$store.state.common.appMode; 
    }, 
  }, 
  methods: { 
    routerLink($event, redirectTo) { 
      // redirect to page 
      if (redirectTo) { 
        this.$router.push({ path: redirectTo.url, query: redirectTo.params }); 
      } else { 
        const href = {}; 
        this.findHref($event.target, href, 2, 0); 
 
        const exactMatchSafeList = [
          // Homepage
          "/",

          // France
          "/france",
          "/france/corsica",
          "/france/corsica/towns-and-cities-in-corsica/ajaccio",
          "/france/corsica/towns-and-cities-in-corsica/bonifacio",
          "/france/corsica/towns-and-cities-in-corsica/calvi",
          "/france/corsica/towns-and-cities-in-corsica/porto-vecchio",
          "/france/corsica/towns-and-cities-in-corsica/sartene",

          // Greece
          "/greece",
          "/greece/aegina",
          "/greece/alonissos",
          "/greece/alonissos/towns-and-cities-of-alonissos/alonissos-old-town",
          "/greece/antiparos",
          "/greece/corfu",
          "/greece/corfu/towns-and-cities-in-corfu/corfu-town",
          "/greece/corfu/towns-and-cities-in-corfu/old-perithia",
          "/greece/cyclades",
          "/greece/dodecanese",
          "/greece/evia",
          "/greece/hydra",
          "/greece/ionian",
          "/greece/kastos",
          "/greece/kea",
          "/greece/kefalonia",
          "/greece/lefkada",
          "/greece/lefkada/towns-and-cities-of-lefkada/lefkada-town",
          "/greece/mainland",
          "/greece/meganissi",
          "/greece/mykonos",
          "/greece/paros",
          "/greece/patmos",
          "/greece/paxos-and-antipaxos",
          "/greece/porto-heli",
          "/greece/saronic",
          "/greece/serifos",
          "/greece/skiathos",
          "/greece/skopelos",
          "/greece/skopelos/towns-and-cities-on-skopelos/skopelos-town",
          "/greece/spetses",
          "/greece/sporades",
          "/greece/syros",
          "/greece/tinos",
          "/greece/zakynthos",

          // Italy
          "/italy",
          "/italy/puglia",
          // '/italy/puglia/the-salento', review link
          "/italy/puglia/towns-and-cities-in-puglia/alberobello",
          "/italy/puglia/towns-and-cities-in-puglia/bari",
          "/italy/puglia/towns-and-cities-in-puglia/brindisi",
          // '/italy/puglia/towns-and-cities-in-puglia/castro',
          "/italy/puglia/towns-and-cities-in-puglia/cisternino",
          "/italy/puglia/towns-and-cities-in-puglia/galatina",
          "/italy/puglia/towns-and-cities-in-puglia/gallipoli",
          "/italy/puglia/towns-and-cities-in-puglia/lecce",
          "/italy/puglia/towns-and-cities-in-puglia/locorotondo",
          "/italy/puglia/towns-and-cities-in-puglia/martina-franca",
          "/italy/puglia/towns-and-cities-in-puglia/matera",
          "/italy/puglia/towns-and-cities-in-puglia/monopoli",
          "/italy/puglia/towns-and-cities-in-puglia/ostuni",
          "/italy/puglia/towns-and-cities-in-puglia/otranto",
          "/italy/puglia/towns-and-cities-in-puglia/polignano-a-mare",
          "/italy/puglia/towns-and-cities-in-puglia/santa-maria-di-leuca",
          // '/italy/puglia/towns-and-cities-in-puglia/specchia'
          "/italy/puglia/towns-and-cities-in-puglia/taranto",
          "/italy/puglia/towns-and-cities-in-puglia/trani",
          // '/italy/puglia/valle-d-itria', review link

          "/italy/sicily",
          "/italy/sicily/towns-and-cities-in-sicily/acireale",
          // '/italy/sicily/towns-and-cities-in-sicily/agira',
          // '/italy/sicily/towns-and-cities-in-sicily/agrigento',
          "/italy/sicily/towns-and-cities-in-sicily/caltagirone",
          "/italy/sicily/towns-and-cities-in-sicily/castellammare-del-golfo",
          "/italy/sicily/towns-and-cities-in-sicily/catania",
          "/italy/sicily/towns-and-cities-in-sicily/cefalu",
          // '/italy/sicily/towns-and-cities-in-sicily/chiaramonte-gulfi',
          // '/italy/sicily/towns-and-cities-in-sicily/enna',
          "/italy/sicily/towns-and-cities-in-sicily/erice",
          "/italy/sicily/towns-and-cities-in-sicily/marsala",
          "/italy/sicily/towns-and-cities-in-sicily/marzamemi",
          "/italy/sicily/towns-and-cities-in-sicily/mazara-del-vallo",
          "/italy/sicily/towns-and-cities-in-sicily/menfi",
          // '/italy/sicily/towns-and-cities-in-sicily/messina',
          "/italy/sicily/towns-and-cities-in-sicily/milazzo",
          "/italy/sicily/towns-and-cities-in-sicily/modica",
          "/italy/sicily/towns-and-cities-in-sicily/mondello",
          // '/italy/sicily/towns-and-cities-in-sicily/monreale',
          "/italy/sicily/towns-and-cities-in-sicily/noto",
          // '/italy/sicily/towns-and-cities-in-sicily/palazzolo-acreide',
          "/italy/sicily/towns-and-cities-in-sicily/palermo",
          "/italy/sicily/towns-and-cities-in-sicily/piazza-armerina",
          "/italy/sicily/towns-and-cities-in-sicily/pozzallo",
          "/italy/sicily/towns-and-cities-in-sicily/ragusa",
          "/italy/sicily/towns-and-cities-in-sicily/sciacca",
          "/italy/sicily/towns-and-cities-in-sicily/scicli",
          "/italy/sicily/towns-and-cities-in-sicily/scopello",
          "/italy/sicily/towns-and-cities-in-sicily/syracuse",
          "/italy/sicily/towns-and-cities-in-sicily/taormina",
          "/italy/sicily/towns-and-cities-in-sicily/trapani",

          // Tuscany redirect from CMS to Builder in order to use page ID and page type
          "/italy/tuscany"
        ];

        if (href.path) {
          if (
            !href.path.includes("http") &&
            !href.path.includes("tel:") &&
            !href.path.includes("mailto:") &&
            !href.path.includes(".pdf") &&
            // Splash pages - starts with
            !href.path.startsWith("/blog") &&
            !href.path.startsWith("/results") &&
            !href.path.startsWith("/enquiries") &&
            !href.path.startsWith("/careers") &&
            !href.path.startsWith("/italy/sicily/villas/") &&
            !href.path.startsWith("/italy/puglia/villas/") &&
            !href.path.startsWith("/italy/tuscany/villas/") &&
            !href.path.startsWith("/france/corsica/villas/") &&
            !href.path.startsWith("/greece/evia/villas/") &&
            !href.path.startsWith("/greece/porto-heli/villas/") &&
            !href.path.startsWith("/greece/antiparos/villas/") &&
            !href.path.startsWith("/greece/kea/villas/") &&
            !href.path.startsWith("/greece/mykonos/villas/") &&
            !href.path.startsWith("/greece/paros/villas/") &&
            !href.path.startsWith("/greece/serifos/villas/") &&
            !href.path.startsWith("/greece/syros/villas/") &&
            !href.path.startsWith("/greece/tinos/villas/") &&
            !href.path.startsWith("/greece/patmos/villas/") &&
            !href.path.startsWith("/greece/aegina/villas/") &&
            !href.path.startsWith("/greece/hydra/villas/") &&
            !href.path.startsWith("/greece/spetses/villas/") &&
            !href.path.startsWith("/greece/alonissos/villas/") &&
            !href.path.startsWith("/greece/skiathos/villas/") &&
            !href.path.startsWith("/greece/skopelos/villas/") &&
            !href.path.startsWith("/greece/zakynthos/villas/") &&
            !href.path.startsWith("/greece/lefkada/villas/") &&
            !href.path.startsWith("/greece/paxos/villas/") &&
            !href.path.startsWith("/greece/kastos/villas/") &&
            !href.path.startsWith("/greece/meganissi/villas/") &&
            !href.path.startsWith("/greece/antipaxos/villas/") &&
            !href.path.startsWith("/greece/corfu/villas/") &&
            !href.path.startsWith("/greece/kefalonia/villas/") &&
            // Splash pages - if exactly matches
            !exactMatchSafeList.includes(href.path)
          ) {
            $event.preventDefault();
            this.closeTab();
            window.scrollTo(0, 0);
            this.$router.push({ path: href.path });
          }
        } 
      } 
    }, 
 
    findHref(target, href, deep, ideep) { 
      if ( 
        target && 
        target.tagName && 
        target.tagName.toLowerCase() === 'a' 
      ) { 
        href.path = target.getAttribute('href'); 
      } else if (target && target.tagName && ideep < deep) { 
        this.findHref(target.parentNode, href, deep, ideep++); 
      } 
    }, 
 
    navigateToPath(toPath) { 
      this.$router.push({ 
        path: toPath, 
      }); 
      window.scrollTo(0, 0); 
    }, 
 
    navigateToPage(id, type) { 
      this.$router.push({ 
        path: this.$store.getters['applinks/getLink'](type, id).url, 
      }); 
      window.scrollTo(0, 0); 
    }, 
  }, 
}; 
